import React from 'react'
import cx from 'classnames'

import type {
  TableCellProps,
  TableCellType,
} from 'components/shared/Table/types'
import styles from './TableCell.module.scss'

const BODY = 'body'
const HEAD = 'head'

const CELL_TYPES: Record<TableCellType, 'td' | 'th'> = {
  [BODY]: 'td',
  [HEAD]: 'th',
}

export const TableCell = ({
  children,
  className,
  colSpan,
  maxWidth,
  type = BODY,
  hasIncreasedHeight = false,
}: TableCellProps) => {
  const Cell = CELL_TYPES[type]

  return (
    <Cell
      className={cx(
        styles.cell,
        {
          [styles.head]: type === 'head',
          [styles.higher]: hasIncreasedHeight,
        },
        className,
      )}
      colSpan={colSpan}
      style={{ maxWidth }}
    >
      {children}
    </Cell>
  )
}
